import React, { useState, useEffect } from 'react';
import { WA_PEDIDOS } from '../constants';
import { BanderaMX } from './PapelPicado';

const images = [
  '/sep/redes.jpg',
  '/sep/paella.jpg',
  '/sep/paquete.jpg',
  '/sep/2x1.jpg',
];

const Banner: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full bg-[#05603c]">
      {/* Slider — object-contain muestra la imagen completa sin recortar */}
      <div
        className="relative w-full mx-auto overflow-hidden bg-[#033f28]"
        style={{ height: 'clamp(240px, 52vw, 680px)' }}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="absolute inset-0 flex justify-center items-center"
            style={{
              transform: `translateX(${(index - currentIndex) * 100}%)`,
              transition: 'transform 1s ease-in-out',
            }}
          >
            <img
              src={image}
              alt={`Promoción ${index + 1}`}
              className="w-full h-full object-contain"
            />
          </div>
        ))}

        {/* Dots indicator */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 z-10">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 border-2 border-white ${
                currentIndex === index ? 'bg-white scale-125' : 'bg-white/40'
              }`}
            />
          ))}
        </div>

        {/* Flechas de navegación */}
        <button
          onClick={() => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length)}
          className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl transition-all z-10"
        >
          ‹
        </button>
        <button
          onClick={() => setCurrentIndex((prev) => (prev + 1) % images.length)}
          className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl transition-all z-10"
        >
          ›
        </button>
      </div>

      {/* Thumbnails */}
      <div className="flex justify-center gap-2 py-3 bg-[#033f28]">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Miniatura ${index + 1}`}
            onClick={() => setCurrentIndex(index)}
            className={`w-16 h-16 object-cover cursor-pointer rounded transition-all duration-300 ${
              currentIndex === index
                ? 'border-2 border-brand-deep scale-110 shadow-md'
                : 'border-2 border-transparent opacity-60 hover:opacity-100'
            }`}
          />
        ))}
      </div>

      {/* Texto descriptivo + mascota */}
      <div className="bg-[#05603c] py-6 px-4">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 max-w-[900px] mx-auto">
          {/* Mascota */}
          <div className="relative flex-shrink-0 group">
            {/* Brillo naranja detrás en hover */}
            <div className="absolute inset-0 rounded-3xl blur-xl bg-[#ff6d00] opacity-0 group-hover:opacity-30 transition-opacity duration-500" />
            <img
              src="/sep/logo.jpg"
              alt="Mascota El Chel"
              className="relative w-[clamp(150px,20vw,240px)] h-auto object-contain rounded-3xl border-4 border-brand-deep group-hover:border-[#ff6d00] group-hover:scale-105 group-hover:shadow-[0_0_25px_rgba(255,109,0,0.6)] transition-all duration-500"
            />
          </div>
          {/* Texto y botón */}
          <div className="text-center md:text-left">
            <h1 className="text-[clamp(1.8rem,3.6vw,3rem)] font-extrabold text-white mb-3">
              <BanderaMX /> EL CHEL — Cochinita Pibil <BanderaMX />
            </h1>
            <p className="text-[clamp(1.05rem,2.2vw,1.3rem)] text-[#ff6d00] max-w-[600px] leading-relaxed mb-4">
              Cochinita pibil, sopa de lima, paella y más — Desde 1978 en la Ciudad de México.
              Tres sucursales en Tlalpan. El sabor que conquista generaciones.
            </p>
            <button
              onClick={() => window.open(WA_PEDIDOS, '_blank')}
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-brand-deep text-white font-bold text-lg uppercase tracking-wide shadow-brand-strong hover:bg-[#e65100] transition-colors duration-300"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
              </svg>
              Pedir por WhatsApp
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
